import { useTranslation } from "react-i18next";
import dompurify from "dompurify";
import InputText from "../../../components/shared/input-text/component";
import { Helmet } from "react-helmet";
import Footer from "../../../components/footer/component";
import { currentDomain } from "../../../utils/general-config";
import { DomainName } from "../../../utils/constants";

const PSRResetPassword = ({
  onpasswordChange,
  password,
  onconfirmPasswordChange,
  confirmPassword,
  pwdErrorMsg,
  saveClickHandler,
}) => {
  const { t } = useTranslation();
  const sanitizer = dompurify.sanitize;
  let Domain = currentDomain().toLowerCase();
  return (
    <>
      <Helmet>
        <meta name="description" content={t("reset_password.ps.description_meta")} />
        <title>
          {Domain === DomainName.PDFSIMPLI ? t("page_title.ps.reset_password") : t("page_title.ws.reset_password")}
        </title>
      </Helmet>
      <div className="backdrop-blur-[100px] bg-blur-bg-rs">
        <section className="main-content !min-h-[calc(100vh-9.7rem)] pt-0 md-!pt-[40px] pb-0 md:pb-10">
          <div className="container mx-auto">
            <div className="form-wrap-psr relative p-[2px] rounded-tl-[14px] rounded-tr-[14px] rounded-bl-[50px] rounded-br-[50px] bg-rs-border-gradient">
              <div className="rounded-tl-[14px] rounded-tr-[14px] rounded-bl-[50px] rounded-br-[50px] py-8 px-4 bg-white shadow-md">
                <div className="form-wrap text-center">
                  <div className="form-container font-rethink">
                    <hgroup className="text-center user-page">
                      <div>
                        <h1 className="text-[#16283D] font-poppins text-2xl md:text-4xl font-bold md:font-bold mt-0 mb-2.5">
                          {t("reset_password.ps.headline")}
                        </h1>

                        <p className="form-signin-heading text-center  text-[#16283D] font-semibold text-base md:text-lg mb-6">
                          {t("reset_password.pls_enter_password")}
                        </p>
                      </div>
                    </hgroup>
                    <div className="form-text my-2">
                      <small className="form-text text-base text-red-500 font-normal">{pwdErrorMsg}</small>
                    </div>
                    <div className="form-group ">
                      <InputText
                        showLabel={false}
                        className="border-gray-300 rounded  p-2 border mb-2 max-w-96 text-[14px] font-normal"
                        required="required"
                        id="password"
                        text="Password"
                        type="password"
                        name="password"
                        maxlength="128"
                        onChange={onpasswordChange}
                        value={password}
                        placeholder={t("reset_password.placeholder_new_password")}
                      />
                    </div>
                    <p className="text-sm font-normal text-[#0E77FF] mt-2 mb-4 text-left">
                      {t("reset_password.remember_your_password_text")} <br className="hidden md:inline" />{" "}
                      {t("reset_password.text_length")}
                    </p>
                    <div className="form-group">
                      <InputText
                        showLabel={false}
                        className=" border-gray-300 rounded  p-2 border mb-2 max-w-96 text-[14px] font-normal"
                        required="required"
                        id="confirmPassword"
                        text="Password"
                        type="password"
                        name="confirmPassword"
                        maxlength="128"
                        onChange={onconfirmPasswordChange}
                        value={confirmPassword}
                        placeholder={t("reset_password.placeholder_confirm_password")}
                      />
                    </div>
                    <div className=" fbn bounce-effect md:fixed md:relative bottom-0 left-0 bg-white  border-gray-300 p-2 md:p-0 lg:p-0 text-center w-full my-[15px] z-50">
                      <button
                        className="text-white p-4 w-full leading-[120%] font-rethink tracking-[2%] text-md md:text-xl font-bold rounded-[100px] bg-ps-reskin-radial hover:bg-hover-ps-reskin-radial uppercase
 transition-colors duration-1000 ease-in-out"
                        isLoading={false}
                        disabled={false}
                        type="submit"
                        id="reset-password-btn"
                        onClick={saveClickHandler}
                      >
                        {t("reset_password.ps.headline")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};

export default PSRResetPassword;
